import script from "./faq_categories.vue?vue&type=script&setup=true&lang=js"
export * from "./faq_categories.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__